import { PropsWithChildren } from 'react'

type ProductsContainerProps = {}

export const ProductsContainer = ({
  children
}: PropsWithChildren<ProductsContainerProps>) => {
  return <div className="flex flex-col gap-16 py-8">{children}</div>
}
